import { Client } from "../../../client";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { proccessErrorMessage } from "../../../Helper/proccessErrorMessage";
import { API_PAY_HALAL_STOCK_DIVIDEND } from "../../../config/api";
import { getStock } from "./getStock";

export const payDividend = createAsyncThunk(
  "stocks/payDividend",
  async ({ id, data, callback }, { dispatch, rejectWithValue }) => {
    try {
      const response = await Client({
        method: "POST",
        path: API_PAY_HALAL_STOCK_DIVIDEND(id),
        data: data,
      });
      toast.success("Dividend payment initiated successfully");
      dispatch(getStock(id));
      callback && callback(response?.data?.data);
      return response?.data?.data;
    } catch (error) {
      const msg = proccessErrorMessage(error);
      toast.error(msg);
      return rejectWithValue(error.message);
    }
  }
);
